import React from "react";

import cx from "classnames";

import { useMedia } from "~/lib/hooks";
import Popup from "~/ui/legacy/Popup";

import ThumbsButton, { ThumbsIcon } from "./Button";

import styles from "./Trigger.module.css";

export default function Trigger({
	onClick,
	feedbackSent,
	feedbackCount,
	className,
}: {
	onClick: () => void;
	feedbackSent: boolean;
	feedbackCount: number;
	className?: string;
}) {
	const trigger = (
		<section className={cx(styles.trigger, { [styles.readonly]: feedbackSent }, className)}>
			{feedbackSent ? <ThumbsIcon value="up" /> : <ThumbsButton value="up" onClick={onClick} />}
			{feedbackCount > 0 && <b className={styles.count}>{feedbackCount}</b>}
		</section>
	);

	const hasHover = useMedia("(hover: hover)");

	if (!hasHover) return trigger;

	return (
		<Popup
			inverted
			size="tiny"
			content={feedbackSent ? "You already responded" : "How was this meeting?"}
			position="top center"
			trigger={trigger}
			className={styles.popup}
		/>
	);
}
